"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  BoostPricingTile: true
};
exports.BoostPricingTile = void 0;
var _react = _interopRequireDefault(require("react"));
var _types = require("../../../types");
var _consts = require("../../../consts");
var _PricingTile = require("./PricingTile");
Object.keys(_PricingTile).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _PricingTile[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _PricingTile[key];
    }
  });
});
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var BoostPricingTile = exports.BoostPricingTile = function BoostPricingTile(props) {
  var _boostProductTierConf, _boostProductTierConf2;
  var tier = props.tier,
    isMobile = props.isMobile,
    selectedTerm = props.selectedTerm,
    isHighlighted = props.isHighlighted,
    theme = props.theme,
    _props$isSecondaryJoi = props.isSecondaryJoinVisible,
    isSecondaryJoinVisible = _props$isSecondaryJoi === void 0 ? false : _props$isSecondaryJoi,
    _props$onJoin = props.onJoin,
    onJoin = _props$onJoin === void 0 ? function () {} : _props$onJoin,
    promotionPercentOff = props.promotionPercentOff,
    promotionCredit = props.promotionCredit;
  var tierConfig = (_boostProductTierConf = _consts.boostProductTierConfig_v3[selectedTerm]) === null || _boostProductTierConf === void 0 ? void 0 : _boostProductTierConf[tier];
  var secondaryTerm = selectedTerm === _types.BoostTerm.MONTHLY ? _types.BoostTerm.YEARLY : _types.BoostTerm.MONTHLY;
  var secondaryTierConfig = (_boostProductTierConf2 = _consts.boostProductTierConfig_v3[secondaryTerm]) === null || _boostProductTierConf2 === void 0 ? void 0 : _boostProductTierConf2[tier];
  var featuresMobile = tierConfig.featuresMobile;
  var features = featuresMobile;
  var tileTheme = isHighlighted ? "light" : theme === "white" ? "light" : "dark";
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_PricingTile.BoostPricingTileComponent, {
    isMobile: Boolean(isMobile),
    isHighlighted: Boolean(isHighlighted),
    tileTheme: tileTheme,
    tier: tier,
    term: selectedTerm,
    secondaryConfig: secondaryTierConfig,
    isSecondaryJoinVisible: isSecondaryJoinVisible,
    buttonText: "Get ".concat(tierConfig.name.toLowerCase() === 'basic' ? "Starter" : tierConfig.buttonText || tierConfig.name),
    features: features,
    onJoin: onJoin,
    promotionPercentOff: promotionPercentOff,
    promotionCredit: promotionCredit
  }));
};